/**
 * Copyright Motili Inc., 2019 All Rights Reserved
 */

import { createHashHistory } from 'history';

export default createHashHistory();
